import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_bnj.png",
      alt: "BNJ Analytics",
    },
    title: "Os modelos Lion superaram os mercados em todo o mundo",

    // String ou array de strings
    text: [
      "Com mais de 24 anos de experiência nos mercados financeiros, a BNJ Analytics está na vanguarda da inovação em algoritimos e sinais de negociação de ações. Somos especializados em fornecer estratégias e sinais precisos de negociação que capacitam investidores em todo o mundo a tomar decisões e atingir seus objetivos financeiros. ",
      "Nossa expertise abrange os principais mercados, incluindo Estados Unidos, China, Índia e, mais recentemente, Brasil. Nossos algoritmos de ponta têm consistentemente fornecido insights confiáveis e vantagens estratégicas para traders nesses mercados diversos e dinâmicos. ",
      "Na BNJ Analytics, nós aproveitamos nossa vasta experiência e tecnologia avançada para oferecer sinais de negociação proprietários que são adaptados ao seu perfil. Seja você um investidor experiente ou iniciante, agressivo ou mais moderado, nossos sinais são projetados para maximizar seus retornos.",
      "Não perca a oportunidade de se beneficiar de nossa expertise global. Inscreva-se hoje para obter acesso aos nossos sinais de negociação exclusivos e levar sua negociação para o próximo nível com o BNJ Analytics. ",
    ],
    testimonial: {
      text: "Executamos algoritmos automatizados há mais de 24 anos e temos superado o mercado consistentemente. ",
      author: {
        name: "Michael Liphman, CTO ",
        // picture: "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
      },
    },
  },

  strategies: {
    title: "Modelos Lion",
    heading: "Ao navegar pela selva financeira, siga um Leão. ",
    subtitle: "Nossa tecnologia totalmente automatizada e de ponta está a apenas alguns cliques de distância ",
  },

  cta: {
    title: "Pronto para dominar o mercado?",
    subtitle: "Ative sua estratégia agora",
    // buttonText: "Ativar extensão",
  },

  about: {
    title: "Sobre a empresa",
    subtitle: "A BNJ Analytics",
    col1: [
      "Com mais de 24 anos de experiência nos mercados financeiros, a BNJ Analytics está na vanguarda da inovação de sinais de negociação de ações. Somos especializados em fornecer sinais de negociação precisos e acionáveis que capacitam investidores em todo o mundo a tomar decisões informadas e atingir seus objetivos financeiros. ",
      "Nossa expertise abrange os principais mercados, incluindo Estados Unidos, China, Índia e, mais recentemente, Brasil. Nossos algoritmos de ponta têm consistentemente fornecido insights confiáveis e vantagens estratégicas para traders nesses mercados diversos e dinâmicos. ",
    ],
    col2: [
      "Na BNJ Analytics, nós aproveitamos nossa vasta experiência e tecnologia avançada para oferecer sinais de negociação proprietários que são adaptados às suas necessidades. Seja você um investidor experiente ou apenas começando, nossos sinais são projetados para aprimorar sua estratégia de negociação e maximizar seus retornos potenciais. ",
      "Não perca a oportunidade de se beneficiar de nossa expertise global. Inscreva-se hoje para obter acesso aos nossos sinais de negociação exclusivos e levar sua negociação para o próximo nível com o BNJ Analytics. ",
    ],
  },

  stats: {
    title: "Estatísticas",
    subtitle: "Junte-se à equipe Experiência Mundial",
    data: [
      {
        // value: "+24 anos",
        description: "24 anos de experiência em negociação",
      },
      {
        // value: "3 continentes",
        description: "Negociação em 3 continentes",
      },
      {
        // value: "+15k",
        description: "24 anos de Retornos Positivos",
      },
      // {
      //   value: "+5",
      //   description: "Anos desenvolvendo portfólios",
      // },
    ],
  },

  features: {
    // type: 2,
    title: "Por que utilizar os nossos robôs",
    subtitle: "Veja quais as principais vantagens",
    data: [
      {
        icon: iconsSet.calendar,
        title: "Sete dias de teste gratuito ",
        // description: "Teste nossas estratégias e confira a performance em sua conta.",
      },
      {
        icon: iconsSet.clock,
        title: "24 anos de experiência",
        // description:
        //   "Analisar o mercado financeiro 24 horas por dia, 7 dias por semana: Ele identifica as melhores oportunidades de investimento e realiza as operações automaticamente, para que você não precise se preocupar com nada.",
      },
      {
        icon: iconsSet.code,
        title: "Experiência global agora no mercado brasileiro",
        // description: "Você só precisa assinar e deixar o robô investir para você.",
      },
      {
        icon: iconsSet.hourglass,
        title: "Estratégia que super o mercado de forma consistente.",
        // description:
        //   "Ganhar dinheiro enquanto você dorme: O robô trabalha para você 24 horas por dia, para que você possa aproveitar seu tempo livre sem se preocupar com a renda. ",
      },
      {
        icon: iconsSet.cloud,
        title: "Desenvolvimento de modelos adicionais o tempo todo",
        // description: "Não é preciso instalar nada nem ser expert: tudo é executado em nuvem.",
      },
      {
        icon: iconsSet.chat_round,
        title: "Totalmente automatizado e usando tecnologia de IA de ponta",
        // description: "Nossa equipe está à disposição para tirar suas dúvidas sobre as estratégias e planos.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Tenho trabalhado com membros da equipe da BNJ Analytics há anos, algumas das pessoas mais inteligentes do planeta",
      author: "Matt Monroe",
      job: "Financial Advisor",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Você tem que ver para crer, seus retornos são tremendos. Conheço o dono há mais de 25 anos e eles simplesmente ganham dinheiro todos os dias",
      author: "Larry Rosen",
      job: "Financial Advisor",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos e vantagens!",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
